// extracted by mini-css-extract-plugin
export default {"header-change-container":"desktop24hrHeader_header-change-container__H-Zu7"};